import React from 'react'

import useTranslation from '../../context/hooks/useTranslation'
import { twm } from '../../lib/utils/twm'
import ShipmentState, {
  ShipmentStateKeys,
} from '../../types/enum/ShipmentStates'

export interface StatusBadgeProps {
  status: ShipmentStateKeys
}

const stateClass = {
  [ShipmentState.SHIPMENT_ACCEPTED_BY_DRIVER]: 'onItsWay',
  [ShipmentState.SHIPMENT_SORTED]: 'atCentralHub',
  [ShipmentState.SHIPMENT_SORTED_AT_SUB_DEPOT]: 'atRegionalHub',
  [ShipmentState.EXCEPTION_SHIPMENT_CANCELLED_BY_TRUNKRS]: 'cancelled',
  [ShipmentState.EXCEPTION_SHIPMENT_CANCELLED_BY_SENDER]: 'cancelled',
  [ShipmentState.SHIPMENT_DELIVERED]: 'delivered',
  [ShipmentState.SHIPMENT_DELIVERED_TO_NEIGHBOR]: 'deliveredToNeighbour',
  [ShipmentState.SHIPMENT_NOT_DELIVERED]: 'notDelivered',
  [ShipmentState.EXCEPTION_SHIPMENT_DECLINED_BY_DRIVER]: 'notDelivered',
  [ShipmentState.EXCEPTION_SHIPMENT_NOT_ARRIVED]: 'expected',
  [ShipmentState.DATA_PROCESSED]: 'expected',
  [ShipmentState.EXCEPTION_SHIPMENT_INVESTIGATE]: 'notDelivered',
  [ShipmentState.RETURN_SHIPMENT_TO_SENDER]: 'returned',
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const { t } = useTranslation()

  return (
    <div className="bg-gray-34 flex w-fit flex-row items-center gap-1 rounded-2xl pl-1 pr-[6px]">
      <div
        className={twm(
          'h-[10px] w-[10px] rounded-full',
          stateClass[status] || 'defaultColor',
        )}
      />
      <span className="font-body text-sm">
        {t(`SHIPMENT_STATES.${status}`)}
      </span>
    </div>
  )
}

export default StatusBadge
